import styled from 'styled-components'

export const CartItemContainer = styled.div`
    display: flex;
    gap: 12px;
    padding: 10px 15px;
    border-bottom: 1px solid #e8e8e8;
`
export const ItemImg = styled.img`
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 8px;
    flex-shrink: 0;
    cursor: pointer;
`
export const ItemDetail = styled.div`
    flex: 1;
    min-width: 0;
`
export const DetailRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0px;
    svg{
        cursor: pointer;
    }
`
export const ItemTitle = styled.div`
    font-weight: 600;
    color: #ff6921;
    cursor: pointer;
    &:hover{
        color: #cb0000;
    }
`
export const ItemPrice = styled.div`
    font-weight: 600;
`

export const ItemCountControll = styled.div`
    display: flex;
    align-items: center;
    ${props => props.theme.rtl && `flex-direction: row-reverse;`}
    svg{
        cursor: pointer;
    }
`

export const ItemCount = styled.div`
    width: 30px;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const RemoveProductModalWrapper = styled.div`
    text-align: center;
    padding: 20px 20px 20px 20px;
`
export const ActionGroup = styled.div`
    display: flex;
    justify-content: center;
    > button {
        margin-right: 10px;
    }
`
export const RemoveIcon = styled.div`
`
export const RemoveText = styled.div`
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 20px;
`
export const ItemNote = styled.div`
    font-size: 13px;
    color: #666;
    margin: -4px 0 4px;
    font-style: italic;
`